<template>
  <div class="ds-pagination pager">
    <!-- Lewa sekcja: przejście do pierwszej strony i poprzedniej strony -->
    <div class="pager__group prev">
      <button
        class="pager__btn"
        @click="firstPage()"
        :disabled="currentPage === 1"
        :aria-label="t('first-page')"
      >
        &lt;&lt;
      </button>
      <button
        class="pager__btn"
        @click="previousPage()"
        :disabled="currentPage === 1"
        :aria-label="t('previous-page')"
      >
        &lt;
      </button>
    </div>
    <!-- Środkowa sekcja: input z numerem strony oraz liczba wszystkich stron -->
    <div class="pages">
      <input
        v-model="currentPage"
        size="2"
        type="text"
        @keyup.enter="setPage"
        :aria-label="t('page-number')"
      />
      <span>/ {{ totalPages }}</span> <!-- Wyświetla ilość stron -->
    </div>
    <!-- Prawa sekcja: przejście do następnej i ostatniej strony -->
    <div class="pager__group next">
      <button
        class="pager__btn"
        @click="nextPage()"
        :disabled="currentPage === totalPages"
        :aria-label="t('next-page')"
      >
        &gt;
      </button>
      <button
        class="pager__btn"
        @click="lastPage()"
        :disabled="currentPage === totalPages"
        :aria-label="t('last-page')"
      >
        &gt;&gt;
      </button>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    // Po zamontowaniu komponentu ustaw bieżącą stronę na pageNum z props
    this.currentPage = this.pageNum;
  },
  watch: {
    // Obserwuje zmianę pageNum z props i aktualizuje currentPage
    pageNum(newPage) {
      this.currentPage = newPage;
    },
  },
  props: {
    pageNum: { required: true },   // aktualnie wybrany numer strony (z rodzica)
    pageSize: { required: true },  // ile elementów na stronie
    totalSize: { required: true }, // łączna liczba elementów
  },
  name: "PagePanel",
  data() {
    return {
      currentPage: 1, // lokalny stan numeru strony
    };
  },
  computed: {
    // Liczy całkowitą liczbę stron. Minimum 1 — dla pustej listy licznik pokazuje
    // „1 / 1", a przyciski „następna/ostatnia" są wyszarzone (przy 0 były aktywne).
    totalPages() {
      return Math.max(1, Math.ceil(this.totalSize / this.pageSize));
    },
  },
  methods: {
    // Ustaw stronę po wpisaniu numeru i kliknięciu Enter
    setPage() {
      const page = parseInt(this.currentPage);
      if (!isNaN(page) && page >= 1 && page <= this.totalPages) {
        this.currentPage = page;
        this.emit(); // emituje zdarzenie do rodzica
      } else {
        this.currentPage = this.pageNum; // jeśli wpisano błędną wartość, wraca do poprawnej
      }
    },
    // Przejście do pierwszej strony
    firstPage() {
      this.currentPage = 1;
      this.emit();
    },
    // Przejście do poprzedniej strony
    previousPage() {
      this.currentPage = parseInt(this.currentPage) - 1;
      this.emit();
    },
    // Przejście do następnej strony
    nextPage() {
      this.currentPage = parseInt(this.currentPage) + 1;
      this.emit();
    },
    // Przejście do ostatniej strony
    lastPage() {
      this.currentPage = this.totalPages;
      this.emit();
    },
    // Funkcja emitująca wybraną stronę do komponentu nadrzędnego
    emit() {
      this.$emit("setPage", this.currentPage);
    },
  },
};
</script>

<style scoped>
/* Paginacja: dwie grupy przycisków po bokach, numer strony na środku. */
.pager {
  justify-content: center;
}

.pager__group {
  display: inline-flex;
  align-items: center;
  border: 1px solid var(--border-default);
  border-radius: var(--control-radius);
  overflow: hidden;
  background: var(--surface-primary);
}

.pager__btn {
  min-width: 34px;
  min-height: var(--control-height-sm);
  padding: 0 var(--spacing-sm);
  border: 0;
  background: transparent;
  color: var(--text-secondary);
  font-size: var(--font-size-sm);
  cursor: pointer;
  transition: background-color var(--transition-fast), color var(--transition-fast);
}

.pager__group .pager__btn + .pager__btn {
  border-left: 1px solid var(--border-subtle);
}

.pager__btn:hover:not([disabled]) {
  background: var(--surface-hover);
  color: var(--text-primary);
}

.pager__btn[disabled] {
  color: var(--text-muted);
  opacity: 0.55;
  cursor: not-allowed;
}

.pages {
  display: inline-flex;
  align-items: center;
  gap: var(--spacing-xs);
  margin: 0 var(--spacing-md);
  color: var(--text-secondary);
}

.pager input {
  width: 48px;
  min-height: var(--control-height-sm);
  text-align: center;
}
</style>
